import * as SelectPrimitive from '@radix-ui/react-select';

export const SelectRoot = SelectPrimitive.Root;
